<form [formGroup]="formGroup">
  <input
    type="checkbox"
    formControlName="control"
    [style.width.px]="sizeInPx"
    [style.height.px]="sizeInPx"
    (change)="checkboxStateChanged($event)"
  />
</form>
